import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button
      mat-icon-button
      (click)="toggleTheme()"
      [matTooltip]="tooltipText()"
      class="theme-toggle-btn"
    >
      <mat-icon [class.rotate]="isToggling" class="theme-icon">
        {{ themeIcon() }}
      </mat-icon>
    </button>
  `,
  styles: [
    `
      .theme-toggle-btn {
        color: var(--text-primary);
        transition: all 0.3s ease;
      }

      .theme-toggle-btn:hover {
        background-color: var(--color-primary-light);
        color: var(--text-on-primary);
      }

      .theme-icon {
        transition: transform 0.3s ease;
      }

      .theme-icon.rotate {
        transform: rotate(180deg);
      }

      .theme-toggle-btn:hover .theme-icon {
        transform: scale(1.1);
      }

      .theme-toggle-btn:hover .theme-icon.rotate {
        transform: rotate(180deg) scale(1.1);
      }
    `,
  ],
})
export class ThemeToggleComponent {
  private themeService = inject(ThemeService);

  isToggling = false;

  // Computed para el icono del tema
  themeIcon = computed(() => {
    return this.themeService.currentTheme() === 'light'
      ? 'dark_mode'
      : 'light_mode';
  });

  // Computed para el texto del tooltip
  tooltipText = computed(() => {
    return this.themeService.currentTheme() === 'light'
      ? 'Change to dark mode'
      : 'Change to light mode';
  });

  toggleTheme(): void {
    this.isToggling = true;
    this.themeService.toggleTheme();

    // Reset animation state
    setTimeout(() => {
      this.isToggling = false;
    }, 300);
  }
}
